import React, { useState } from 'react'
import { Button, iconSizes, Stack, Title } from '@common/ui'
import { IconPlus } from '@common/ui/icons'
import { com } from '@eidu/web'
import SemanticLinksStack from './SemanticLinksStack'
import AddOtherSemanticLinkForm, { isOtherKind } from '../input/AddOtherSemanticLinkForm'
import EntityType = com.eidu.entity.type.EntityType
import SemanticLink = com.eidu.entity.analytics.SemanticLink

type OtherEntityTypesStackProps = {
  entityTypes: readonly EntityType[]
  semanticLinks: readonly SemanticLink[]
}

const OtherEntityTypesStack = ({ entityTypes, semanticLinks }: OtherEntityTypesStackProps) => {
  const [showAddForm, setShowAddForm] = useState(false)

  const typesWithLinks = entityTypes.filter(
    (entityType) => isOtherKind(entityType) && semanticLinks.some(({ path }) => path.fromType.equals(entityType.id))
  )

  return (
    <Stack gap={0}>
      <Title order={4}>Other Types</Title>
      <Stack gap="xs" py="md">
        {typesWithLinks.map((entityType) => (
          <SemanticLinksStack
            key={entityType.id.toString()}
            entityTypes={entityTypes}
            entityType={entityType}
            semanticLinks={semanticLinks.filter(({ path }) => path.fromType.equals(entityType.id))}
          />
        ))}
        {showAddForm ? (
          <AddOtherSemanticLinkForm
            entityTypes={entityTypes}
            onSave={() => setShowAddForm(false)}
            onCancel={() => setShowAddForm(false)}
          />
        ) : (
          <Button
            variant="outline"
            leftSection={<IconPlus size={iconSizes.sm} stroke={1.5} />}
            onClick={() => setShowAddForm(true)}
          >
            Add semantic link
          </Button>
        )}
      </Stack>
    </Stack>
  )
}

export default OtherEntityTypesStack
